import classNames from 'classnames';
import { FC } from 'react';

import { popupItemStyles } from '@gem/ui-kit';

import { AvatarTypes } from 'APP/components/Avatar/Avatar';
import { PopupInfoCard } from 'APP/components/PopupInfoCard/PopupInfoCard';
import { SecureChatBadge } from 'APP/components/SecureChatBadge/SecureChatBadge';
import { VerifiedBadge } from 'APP/components/VerifiedBadge/VerifiedBadge';
import { TargetForwardType } from 'APP/constants/forward';
import { GroupType } from 'APP/model/group/groupModel.types';

import { CheckboxRow } from '../CheckboxRow/CheckboxRow';
import { ISharedDataViewItemData } from '../ShareDataView.types';

interface IGroupItemProps {
  data: ISharedDataViewItemData;
  onClick?(): void;
  isSelected: boolean;
  withCheckbox: boolean;
}

export const SharedDataGroupItem: FC<IGroupItemProps> = (props) => {
  const { data, onClick, isSelected, withCheckbox } = props;

  const avatar = (
    <PopupInfoCard
      type={
        data.itemType === TargetForwardType.Channel ? AvatarTypes.Square_20 : AvatarTypes.Round_10
      }
      avatarTitle={data.avatarTitle}
      avatarUrl={data.avatarUrl}
      avatarBackgroundColorIndex={data.avatarColorIndex}
      title={
        data.type === GroupType.SecretGroup ? (
          <>
            <SecureChatBadge />
            {data.avatarTitle}
          </>
        ) : (
          data.avatarTitle
        )
      }
      badge={data.verified && <VerifiedBadge />}
    />
  );

  if (withCheckbox) {
    return (
      <CheckboxRow
        onClick={onClick}
        isSelected={isSelected}
      >
        {avatar}
      </CheckboxRow>
    );
  }

  return (
    <button
      onClick={onClick}
      className={classNames(popupItemStyles.container, popupItemStyles.interactive)}
    >
      {avatar}
    </button>
  );
};
